import { useState } from 'react';
import { Button, Flex, Input } from '@optiaxiom/react';

type Props = {
  buttonLabel: string;
  placeholder: string;
  pending?: boolean;
  onCreate: (label: string) => void;
};

/**
 * Slick inline-create: a subtle "+ Add …" button that expands into an input
 * (Enter to create, Escape to cancel). Reused for both sections and stacks.
 */
export function CreateInline({ buttonLabel, placeholder, pending, onCreate }: Props) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');

  if (!open) {
    return (
      <Button size="sm" appearance="subtle" onClick={() => setOpen(true)}>
        {buttonLabel}
      </Button>
    );
  }

  const submit = () => {
    const v = value.trim();
    if (!v) return;
    onCreate(v);
    setValue('');
    setOpen(false);
  };

  return (
    <Flex flexDirection="row" gap="4" alignItems="center">
      <Input
        value={value}
        placeholder={placeholder}
        autoFocus
        onChange={e => setValue(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') submit();
          if (e.key === 'Escape') setOpen(false);
        }}
      />
      <Button size="sm" appearance="primary" onClick={submit} disabled={pending || !value.trim()}>
        Add
      </Button>
      <Button size="sm" appearance="subtle" onClick={() => setOpen(false)}>
        Cancel
      </Button>
    </Flex>
  );
}
